<script>
export default {
  data() {
    return {
      sidebar_el: true, // true = aberta, false = fechada
    }
  },
  methods: {
    toggleSideM() {
      const sidebar = document.getElementById("sidebar");
      const messages = document.getElementById("messages");
      const appVersion = document.getElementById("app-version");

      if (this.sidebar_el) {
        // fechar
        sidebar.style.width = "0%";
        messages.style.marginLeft = "0%";
        messages.style.transition = "0.95s";
        appVersion.style.display = "none";
      } else {
        // abrir
        if (window.innerWidth >= 992) {
          sidebar.style.width = "12%";
          messages.style.marginLeft = "15%";
        } else {
          sidebar.style.width = "100%";
          messages.style.marginLeft = "0";
        }
        appVersion.style.display = "flex";
      }

      this.sidebar_el = !this.sidebar_el;
    }
  }
}
</script>